import * as React from "react";
import { Box, SxProps, Theme } from "@mui/material";
import { useLanguage } from "./Language";
import { WorldBookDatabaseControl } from "@tlc/ls2pac/app/controls/worldBookDatabaseControl";

interface WorldbookViewWrapperProps {
  sx?: SxProps<Theme>;
}

export const WorldbookViewWrapper: React.FC<WorldbookViewWrapperProps> = ({
  sx,
}) => {
  const { translate } = useLanguage();

  React.useEffect(() => {
    const worldBookView = new WorldBookDatabaseControl();

    return () => {
      worldBookView?.cleanUp();
    };
  }, []);

  return (
    <Box
      sx={{
        ...sx,
      }}
    >
      <div id="worldBookOptionsContainer">
        <div>
          <div className="refinementOptions">
            <label htmlFor="worldBookControl">World Book Database:</label>
            <select id="worldBookControl"></select>
          </div>
        </div>
      </div>
    </Box>
  );
};
